<template>
    <div class="modal fade percent-calculator-modal" id="percentCalculatorModal" tabindex="-1" role="dialog" aria-labelledby="percentCalculatorModalLabel" aria-hidden="true">
        <div class="modal-dialog  modal-lg modal-dialog-scrollable" role="document">
            <div class="modal-content">
                <div class="modal-header p-3 bg-soft-info">
                    <h5 class="modal-title" id="percentCalculatorModalLabel">Percent Calculator</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <i  class="ri-close-line"></i>
                    </button>
                </div>
                <div class="modal-body calc-modal-body">
                    <div class="card">
                        <div class="card-body">
                            <div class="d-flex justify-content-between">
                                <div class="d-fst">
                                    <span>What is</span>
                                    <input type="number" min="1" name="percent1" id="percent1" v-model="percent1" class="input calc11" v-on:keyup.enter="go1" />
                                    <span>% of</span>
                                    <input type="number" min="1" name="amount1" id="amount1" v-model="amount1" class="input calc12 " v-on:keyup.enter="go1" />
                                    <span>?</span>
                                </div>
                                <div class="d-lst">
                                    <div class="d-flex">
                                        <button type="button" class="btn bg-res" name="go1" @click="go1">Go! </button>
                                        <!--<input class="result" type="text2" disabled="disabled" id="result1">-->
                                        <span class=" result" id="result1">{{result1}}</span>

                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>

                    <div class="card">
                        <div class="card-body">
                            <div class="d-flex justify-content-between">
                                <div class="d-fst">
                                    <input type="number" min="1" name="percent2" id="percent2" v-model="percent2" class="input calc11" v-on:keyup.enter="go2" />
                                    <span>is what % of</span>
                                    <input type="number" min="1" name="amount2" id="amount2" v-model="amount2" class="input calc11" v-on:keyup.enter="go2" />
                                    <span>?</span>
                                </div>
                                <div class="d-lst">
                                    <div class="d-flex">
                                        <button type="button" class="btn bg-res" name="go2" @click="go2">Go!</button>
                                        <!--<input class="result" type="text2" disabled="disabled" id="result1">-->
                                        <span class="result" id="result2">{{result2}}</span>
                                        <span class="lstpercnt">%</span>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>

                    <div class="card">
                        <div class="card-body">
                            <div style="margin-bottom: 12px;">What is the percentage increase/decrease</div>
                            <div class="d-flex justify-content-between align-items-center">
                                <div class="d-fst">

                                    <span>From</span>
                                    <input type="number" min="1" name="from_amount" v-model="original_amount" class="input calc31" v-on:keyup.enter="go3" />
                                    <span>To</span>
                                    <input type="number" min="1" name="to_amount" v-model="new_amount" class="input calc32" v-on:keyup.enter="go3" />
                                    <span>?</span>
                                </div>
                                <div class="d-lst">
                                    <div class="d-flex">
                                        <button type="button" class="btn bg-res" name="go3" @click="go3">Go!</button>
                                        <span class="result">{{result3}}</span>
                                        <span class="lstpercnt">%</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="warn mb-0"><i class="fas fa-lightbulb pe-1"></i><span style="font-weight: 500">Tips:</span> Use tab to move to the next field. Use shift-tab to move to the previous field. Press enter to calculate.</div>

                </div>
                <!--<div class="modal-footer">
                    <button type="button" class="btn btn-danger me-1" data-dismiss="modal">Close</button>
                </div>-->
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "PercentCalculatorModal",
    data() {
        return {
            percent1: null,
            amount1: null,
            result1: null,
            percent2: null,
            amount2: null,
            result2: null,
            original_amount: null,
            new_amount: null,
            result3: null,
        }
    },
    mounted() {
        $('.modal-dialog').draggable({
            handle: ".modal-header"
        });
    },
    methods: {
        go1() {
            if(!isNaN(this.percent1) && !isNaN(this.amount1)){
                let result = (this.amount1/100) * this.percent1;
                this.result1 = result.toFixed(2);
            }
        },
        go2() {
            if(!isNaN(this.percent2) && !isNaN(this.amount2) && this.amount2 > 0){
                let result = (this.percent2/this.amount2) * 100;
                this.result2 = result.toFixed(2) + "%";
            }
        },
        go3() {
            if(!isNaN(this.original_amount) && !isNaN(this.new_amount)){
                let increase = this.new_amount - this.original_amount;
                let result = (increase / this.original_amount) * 100;
                this.result3 = result.toFixed(2)+ "%";
            }
        }

    }
}


</script>



<style scoped>

</style>
